import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import parse from "html-react-parser";
import { useAuth } from "../context/AuthContext";

const TypingPerformance = () => {
  const { accuracy, wrongper, actualdep, speed, testcode, exam, category } =
    useParams();
  const [paragraph, setParagraph] = useState("");
  const [wrongdep, setWrongdep] = useState("");
  const [grosspeed, setGrossSpeed] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [cookies] = useCookies(["token", "userData"]);
  const { user, logout } = useAuth();

  const emailId = cookies?.userData?.email_id || "";
  const testresult =
    parseFloat(wrongper) < parseFloat(error) ? "Pass" : "Try Again";

  useEffect(() => {
    const fetchPerformanceStatus = async () => {
      if (!cookies.token) return navigate("/");

      try {
        const res = await fetch(
          "https://auth.ssccglpinnacle.com/api/typingPerformanceStatusTest",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${cookies.token}`,
            },
            body: JSON.stringify({
              paper_code: testcode,
              email_id: emailId,
              exam,
              category,
            }),
          }
        );

        if (res.ok) {
          const data = await res.json();
          const htmlWithStyles = data.paragraph
            .replace(
              /<span class=\"correctword\">/g,
              '<span class="text-black"'
            )
            .replace(
              /<span class=\"wrongword\">/g,
              '<span class="text-green-800 bg-green-200 px-1 mx-[2px] rounded-md text-base inline-block"'
            )
            .replace(
              /<span class=\"missingword\">/g,
              '<span class="text-red-700 bg-pink-200 px-1 mx-[2px] rounded-md text-base inline-block"'
            );

          setParagraph(parse(htmlWithStyles));
          setGrossSpeed(data.grossspeed);
          setWrongdep(data.wrongdep);
          setError(data.error < 0 ? 0 : data.error);
        } else {
          navigate("/");
        }
      } catch (err) {
        navigate("/");
      }
    };

    fetchPerformanceStatus();
  }, [testcode, emailId, exam, category, cookies.token, navigate]);

  const startTest = () => navigate(`/typingparagraph/${exam}/${category}`);

  const StatCircle = ({ label, value, borderColor, textColor }) => (
    <div className="flex flex-col items-center space-y-1">
      <div
        className={`w-32 h-32 rounded-full border-[8px] ${borderColor} flex items-center justify-center text-lg font-semibold ${textColor}`}
      >
        {value}
      </div>
      <div className="text-center text-sm font-medium text-gray-700">
        {label}
      </div>
    </div>
  );

  return (
    <>
      <div className="bg-blue-600 text-white flex flex-col sm:flex-row justify-between items-center px-4 py-2 gap-2 sm:gap-0">
        <p className="truncate">{user?.email_id || "Loading user data..."}</p>
        <p className="text-center">
          SSC TYPING RESULT :
          <span
            className={
              testresult === "Pass"
                ? "text-green-400 ml-1 bg-green-100 px-2 py-0.5 rounded"
                : "text-red-400 ml-1 bg-red-100 px-2 py-0.5 rounded"
            }
          >
            {testresult}
          </span>
        </p>
        <button
          className="bg-black text-white px-3 py-1 rounded"
          onClick={logout}
        >
          Logout
        </button>
      </div>

      <div className="min-h-screen bg-white text-sm md:text-base px-4 py-6 space-y-6">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-4 text-center m-6">
          <StatCircle
            label="Accuracy"
            value={`${accuracy}%`}
            borderColor="border-cyan-500"
            textColor="text-gray-700"
          />
          <StatCircle
            label="Net Speed (WPM)"
            value={speed}
            borderColor="border-orange-500"
            textColor="text-gray-700"
          />
          <StatCircle
            label="Gross Speed (WPM)"
            value={grosspeed}
            borderColor="border-orange-500"
            textColor="text-gray-700"
          />
          <StatCircle
            label="Wrong (Depressions)"
            value={wrongdep}
            borderColor="border-orange-400"
            textColor="text-gray-700"
          />
          <StatCircle
            label="Error"
            value={`${wrongper}%`}
            borderColor="border-pink-500"
            textColor="text-gray-700"
          />
          <StatCircle
            label="Actual Depressions"
            value={actualdep}
            borderColor="border-teal-500"
            textColor="text-gray-700"
          />
        </div>

        <div className="bg-white p-4 rounded-md border border-gray-300 shadow-sm text-justify leading-relaxed font-light">
          {paragraph}
        </div>

        <div className="dashboard-container">
          <div className="typing-notes-content">
            <strong style={{ color: "black" }}>
              ** Notes:-&gt; Your Typed Paragraph: Typing Mistakes
              <strong style={{ color: "red" }}> THE </strong>
              <strong style={{ color: "green" }}>hte</strong>, And
            </strong>
            <strong style={{ color: "black" }}> Skipped are shown in </strong>
            <strong style={{ color: "red" }}>red</strong>.
            <strong style={{ color: "red" }}>
              {" "}
              Words or lines skipped are shown in red.
            </strong>
            <strong style={{ color: "black" }}>
              {" "}
              Additional and wrong typed are shown in{" "}
            </strong>
            <strong style={{ color: "green" }}>green.</strong>
            <strong style={{ color: "green" }}>
              {" "}
              Words or lines Additional typed are shown in green.
            </strong>
          </div>
        </div>

        <div className="flex justify-center">
          <button
            onClick={startTest}
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </>
  );
};

export default TypingPerformance;
